export class CreateServicioPropiedadRequest {
    public id_Propiedad:number = 0
    public id_Servicio:number = 0
    public nroGestionPersonal:string | null  = ""
    public nroCuenta:string | null =""
    public referenciaPago:string | null =""
}
